module.exports = __webpack_public_path__ + "img/test_dark.520055f8.svg";